// extracted by mini-css-extract-plugin
export default {"wrapper":"tips_wrapper__AeIXa","content":"tips_content__Jpknr","subtitle":"tips_subtitle__Y7VO0","subheader":"tips_subheader__x8mvN"};